import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e5ba078c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container py-4 py-lg-5 col-xl-6" }
const _hoisted_2 = { class: "text-center mb-3 mb-lg-5" }
const _hoisted_3 = { class: "row mx-0 shadow bg-white p-4 p-lg-5 rounded-4" }
const _hoisted_4 = { class: "text-center fw-bold fs-6 mb-3 mb-lg-5 lh-lg" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = { class: "row mx-0 px-0 pb-4 gx-3 mb-4 border-bottom" }
const _hoisted_7 = { class: "w-max-content col-lg-4 col-form-label" }
const _hoisted_8 = { class: "col-lg-6" }
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = { class: "row mx-0 px-0 pb-4 gx-3 mb-4 border-bottom" }
const _hoisted_11 = { class: "w-max-content col-lg-4 col-form-label" }
const _hoisted_12 = { class: "col-lg-6" }
const _hoisted_13 = ["placeholder"]
const _hoisted_14 = { class: "row mx-0 px-0 pb-4 gx-3 mb-4 border-bottom" }
const _hoisted_15 = { class: "w-max-content col-lg-4 col-form-label" }
const _hoisted_16 = { class: "col-lg-6" }
const _hoisted_17 = ["placeholder"]
const _hoisted_18 = { class: "d-flex justify-content-start link align-items-center" }
const _hoisted_19 = { class: "d-flex justify-content-center my-3 my-lg-5" }

import Button from '@/components/button/index.vue'
import { useRouter } from 'vue-router'
import { translate } from '@/languages/i18n'
import { computed, ref, watchEffect } from 'vue'
import InputErrorMessage from '@/components/input-error-message/InputErrorMessage.vue'
import { useStore } from 'vuex'
import { AUTH_STORE } from '@/store/constants'

//validate
import useVuelidate from '@vuelidate/core'
import { required, email, maxLength, minLength } from '@vuelidate/validators'

//constant
import { DEFAULT_MAX_JP_TEXT } from '@/constants/number'

//TODO: CA60

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const forgotEmailData = computed(() => store.getters[AUTH_STORE.GETTERS.FORGOT_EMAIL_DATA])
const rules = computed(() => {
  return {
    emailCurrent: {
      required,
      email,
    },
    email: {
      required,
      email,
    },
    secretWord: {
      required,
      minLength: minLength(5),
      maxLength: maxLength(DEFAULT_MAX_JP_TEXT),
    },
  }
})

watchEffect(() => {
  localStorage.removeItem('checkSubmit')
})
const formData = ref(forgotEmailData)

const v$ = useVuelidate(rules, formData)

const router = useRouter()

const onSubmit = (): void => {
  v$.value.$touch()

  if (v$.value.$invalid) {
    return
  }

  router.push('/community/users/forgot_email_confirm')
  store.dispatch(AUTH_STORE.ACTIONS.SET_FORGOT_EMAIL_DATA, formData.value)
  localStorage.setItem('checkConfirm', true)
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref(translate)(`SE45resetEmail`)), 1),
    _createElementVNode("form", {
      onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", _hoisted_4, [
          _createTextVNode(_toDisplayString(_unref(translate)(`CA60heading1`)), 1),
          _hoisted_5,
          _createVNode(_component_router_link, {
            to: "/inquiry",
            class: "link-green"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(translate)('CA60heading2')), 1)
            ]),
            _: 1
          }),
          _createTextVNode(_toDisplayString(_unref(translate)(`CA60heading3`)), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("label", _hoisted_7, _toDisplayString(_unref(translate)('CA60currentMail')), 1),
          _createElementVNode("div", _hoisted_8, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              name: "email-current",
              class: _normalizeClass(["form-control", ['form-control', _unref(v$).emailCurrent.$error ? 'is-invalid' : '']]),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).emailCurrent.$model) = $event)),
              placeholder: _unref(translate)('placeholder')
            }, null, 10, _hoisted_9), [
              [
                _vModelText,
                _unref(v$).emailCurrent.$model,
                void 0,
                { trim: true }
              ]
            ]),
            _createVNode(InputErrorMessage, {
              title: 'email',
              validator: _unref(v$).emailCurrent.$errors[0]?.$validator
            }, null, 8, ["validator"])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("label", _hoisted_11, _toDisplayString(_unref(translate)('CA60emailToChange')), 1),
          _createElementVNode("div", _hoisted_12, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              name: "email",
              class: _normalizeClass(["form-control", ['form-control', _unref(v$).email.$error ? 'is-invalid' : '']]),
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(v$).email.$model) = $event)),
              placeholder: _unref(translate)('placeholder')
            }, null, 10, _hoisted_13), [
              [
                _vModelText,
                _unref(v$).email.$model,
                void 0,
                { trim: true }
              ]
            ]),
            _createVNode(InputErrorMessage, {
              title: 'email',
              validator: _unref(v$).email.$errors[0]?.$validator
            }, null, 8, ["validator"])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("label", _hoisted_15, _toDisplayString(_unref(translate)('SA20secretWord')), 1),
          _createElementVNode("div", _hoisted_16, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              name: "secretWord",
              class: _normalizeClass(["form-control", ['form-control', _unref(v$).secretWord.$error ? 'is-invalid' : '']]),
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(v$).secretWord.$model) = $event)),
              placeholder: _unref(translate)('placeholder')
            }, null, 10, _hoisted_17), [
              [
                _vModelText,
                _unref(v$).secretWord.$model,
                void 0,
                { trim: true }
              ]
            ]),
            _createVNode(InputErrorMessage, {
              title: _unref(translate)('SA20secretWord'),
              validator: _unref(v$).secretWord.$errors[0]?.$validator
            }, null, 8, ["title", "validator"])
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createVNode(_component_router_link, {
            to: "/users/forgot_password",
            class: "black-link"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(translate)('forgotPassword')), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createVNode(Button, {
          title: _unref(translate)('submit'),
          type: 'secondary',
          onClick: onSubmit
        }, null, 8, ["title"])
      ])
    ], 32)
  ]))
}
}

})